/** Mastercard + havale banka rozetleri — payment-brand-logos.md */
export function PaymentBrandLogos({ surface = 'light', banks = [] }) {
  const stripClass = `pp-brand-logo-strip pp-brand-logo-strip--${surface}`;
  return (
    <div className={stripClass} data-brand-logo-slot="billing-checkout" aria-label="Kabul edilen ödeme yöntemleri">
      <img
        className="pp-brand-logo-strip__img pp-brand-logo-strip__img--scheme"
        src="/static/img/mastercard/ma_symbol.svg"
        alt="Mastercard"
        title="Mastercard"
        width={54}
        height={32}
        loading="lazy"
        decoding="async"
      />
      {banks.length > 0 ? (
        banks.map((bank) => (
          <img
            key={bank.slug || bank.url}
            className="pp-brand-logo-strip__img pp-brand-logo-strip__img--bank"
            src={bank.url}
            alt={bank.label || bank.slug || 'Banka'}
            title={bank.label || bank.slug || 'Banka'}
            width={120}
            height={36}
            loading="lazy"
            decoding="async"
          />
        ))
      ) : (
        <span className="pp-brand-logo-strip__placeholder">Banka logoları yüklenemedi</span>
      )}
    </div>
  );
}
